module.exports = __webpack_public_path__ + "img/21.e977db81.png";